import { gql } from 'urql';

const ChangePasswordInitiate = gql`
  mutation ChangePasswordInitiate($input: ChangePasswordInitiateInput!) {
    changePasswordInitiate(input: $input) {
      ... on ChangePasswordInitiateSuccess {
        code
        customerInfo {
          phone
        }
        __typename
      }
      ... on ChangePasswordTooManyAttempts {
        code
        title
        message
        __typename
      }

      ... on ChangePasswordError {
        code
        title
        message
        __typename
      }

      ... on ChangePasswordOldPasswordIncorrect {
        code
        title
        message
        __typename
      }

      ... on ChangePasswordTooManyPasswordAttempts {
        code
        title
        message
        __typename
      }
    }
  }
`;
export default ChangePasswordInitiate;
